import { useFlags } from 'launchdarkly-react-client-sdk';

export const useFlag = (flag: Flag) => {
	const flags = useFlags();

	return !!flags[flag];
};

type Flag = 'teamCoreCodelistCodelistEnabled' | 'teamTrialsTrialsEnabled';
